import { render, staticRenderFns } from "./mobileproduct.vue?vue&type=template&id=4b42d088"
import script from "./mobileproduct.vue?vue&type=script&lang=js"
export * from "./mobileproduct.vue?vue&type=script&lang=js"
import style0 from "./mobileproduct.vue?vue&type=style&index=0&id=4b42d088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports